module.exports = __webpack_public_path__ + "static/todoist_4-d93d1e109c558296223e4582d76b515b.png";